module.exports = __webpack_public_path__ + "media/images/front/icons/alert-light-c74a6a92601840e302fa1d17d5507650.svg";